import ListaObjetosConId from "../tipos/listaObjetosConId";
import { crearEstacion, FIELD_NOMBRE } from "./estacion";
import TriStateUtils from "../../utils/triStateUtils";
import { compareAttrStrLowerCase } from "../../utils/sortUtils";
import MetConstants from "../datosVars/metConstants";
import { TIPO_ORDEN_CUSTOM } from "../tipos/ordenListaObjetosConId";
import {
  createOrdenEstacionesCustom,
  TIPO_ORDEN_ESTACIONES_NOMBRE,
} from "./ordenEstaciones";

class ListaEstaciones extends ListaObjetosConId {
  constructor(objetos) {
    super(objetos, crearEstacion);
  }

  /**
   * Crea una instancia concreta de la lista
   */
  createNewList() {
    return new ListaEstaciones();
  }

  /**
   * Retorna una lista de estaciones filtradas segun los parametros de filtrado definidos en el argumento filtros.
   * No modifica la lista original.
   *
   * @param {import('./filtrosEstaciones').default} filtros
   * @returns {ListaEstaciones} Lista filtrada de estaciones
   */
  filtrar(filtros) {
    let res = new ListaEstaciones();
    this.list.forEach((est) => {
      if (
        !filtros ||
        ((!filtros.gerencias || filtros.gerencias.includes(est.gerencia)) &&
          TriStateUtils.checkBool(filtros.automaticas, est.tipoAutomatica) &&
          TriStateUtils.checkBool(
            filtros.convencionales,
            !est.tipoAutomatica
          ) &&
          TriStateUtils.checkBool(filtros.aeronauticas, est.tipoAeronautica))
      ) {
        res.add(est);
      }
    });
    return res;
  }

  getListaNombres(ids) {
    return this.getFieldValsArrays(FIELD_NOMBRE, ids);
  }

  /**
   * Retorna una lista ordenada de estaciones segun los parametros de ordenacion definidos por ordenEstaciones
   *
   * @param {OrdenEstaciones} ordenEstaciones - Definicion del orden a aplicar a la lista de estaciones resultante.
   *
   */
  sort(ordenEstaciones) {
    if (!ordenEstaciones) ordenEstaciones = createOrdenEstacionesCustom();
    if (ordenEstaciones.tipo === TIPO_ORDEN_ESTACIONES_NOMBRE)
      return this.sortPorNombre();
    else if (ordenEstaciones.tipo === TIPO_ORDEN_CUSTOM) {
      return this.sortCopyCustom(ordenEstaciones.ids, ListaEstaciones);
    }
    return this.sortPorGerenciaTipoNombre(ordenEstaciones.gerencias);
  }

  /**
   * Retorna una lista de estaciones ordenadas segun las gerencias, luego el tipo y por ultimo el nombre.
   * No afecta el objeto original.
   * @param {*} ordenGerencias - objeto donde cada atributo corresponde a una gerencia. El valor de cada atributo
   * debe ser un numero que indica la posicion de cada gerencia en la lista resultante.
   * @returns {ListaEstaciones} - lista ordenada
   */
  sortPorGerenciaTipoNombre(ordenGerencias) {
    let ordenGerenciasAux = ordenGerencias
      ? ordenGerencias
      : MetConstants.gerenciasOrdenDefecto;
    return this.sortCopy((o1, o2) => {
      if (ordenGerenciasAux[o1.gerencia] < ordenGerenciasAux[o2.gerencia])
        return -1;
      else if (ordenGerenciasAux[o1.gerencia] > ordenGerenciasAux[o2.gerencia])
        return 1;
      if (!o1.tipoAutomatica && o2.tipoAutomatica) {
        return 1;
      } else if (o1.tipoAutomatica && !o2.tipoAutomatica) {
        return -1;
      } else return compareAttrStrLowerCase(o1, o2, FIELD_NOMBRE);
    }, ListaEstaciones);
  }

  /**
   * Retorna una lista de estaciones ordenadas segun las gerencias, luego el tipo y por ultimo el nombre.
   * No afecta el objeto original.
   * @param {*} ordenGerencias - objeto donde cada atributo corresponde a una gerencia. El valor de cada atributo
   * debe ser un numero que indica la posicion de cada gerencia en la lista resultante.
   * @returns {ListaEstaciones} - lista ordenada
   */
  sortPorNombre() {
    return this.sortCopy((o1, o2) => {
      return compareAttrStrLowerCase(o1, o2, FIELD_NOMBRE);
    }, ListaEstaciones);
  }

  getPorIdAutomatica(idAutomatica) {
    return this.list.find((e) => {
      return e.idAutomatica === idAutomatica;
    });
  }
}

export { ListaEstaciones as default };
